import { ErrorBoundary } from "@app/error-boundary";
import { useProfile } from "@features/profile/hooks/use-profile.hook";
import { useProfileStore } from "@features/profile/profile.store";
import { useSettingsStore } from "@shared/store/settings.store";
import { SidebarInset, SidebarProvider } from "@shared/ui/sidebar";
import { Outlet } from "@tanstack/react-router";

import Header from "@widgets/header/header";
import { AppSidebar } from "@widgets/sidebar/app-sidebar";
import { useEffect } from "react";

export function AppLayout() {
	const { data: profile } = useProfile();

	const { setProfile } = useProfileStore();
	const { isSidebarOpen, setSidebarOpen } = useSettingsStore();

	useEffect(() => {
		if (profile) setProfile(profile);
	}, [profile, setProfile]);

	return (
		<SidebarProvider open={isSidebarOpen} onOpenChange={setSidebarOpen}>
			<AppSidebar />
			<SidebarInset>
				<Header />
				<main className="flex flex-1 p-4 w-full">
					<ErrorBoundary>
						<Outlet />
					</ErrorBoundary>
				</main>
			</SidebarInset>
		</SidebarProvider>
	);
}
